import {CP, initParam} from "../setting/initParam";
import {
    calcExtendForOffsetLine, CalcPlaceFromDiagonalIntersectDiagonal, centeredLine, createDefaultMaterial,
    getMetaNumber,
    getOffsetsAfterRotation, InitialStruct,
    JoinPlane,
    JoinType,
    JoinVariant,
    Line2,
    matBeam, ParamsGetSimpleBoard, RenderElement,
    RenderStruct, simpleSize, Vec3
} from "@3dcalc/3dpClient";
import {api} from "../api/api";
import {InitialStructWhithBlock} from "@3dcalc/3dpClient/dist/types/types";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";


export async function getF4(s:InitialStructWhithBlock, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {

    if (s.w > 6) {
        initParam.angles.f4 = 30
    } else {
        initParam.angles.f4 = 20
    }

    const angleF4 = initParam.angles.f4

    const H = initParam.elementData.f2.sizeBoard.l - initParam.gash.simple - initParam.gash.simple
    const placeInfo = CalcPlaceFromDiagonalIntersectDiagonal(CP.maps.f3.diagonal, angleF4)

    const line: Line2 = [[0, 0], [placeInfo.w, placeInfo.h]]
    const extendL = calcExtendForOffsetLine(line, CP.maps.f3.diagonal, sBoard.h)

    CP.maps.f4.point = [placeInfo.w, placeInfo.h]

    // const resultCalcPlaceFromDiagonalL2 = CalcPlaceFromDiagonalY(s.a, H)
    //
    // const placeInfo = resultCalcPlaceFromDiagonalL2.l
    //
    // initParam.elementData.f3.sizeBoard.l = placeInfo



    const paramsGetSimpleBoard: ParamsGetSimpleBoard = {
        modeBuild: modeBuild,
        shift: {back: 0, front: 0},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l:  s.w > 6 ? placeInfo.l : placeInfo.l + extendL},
        cuts: [],
        joinStart: {
            joinType: JoinType.Start,
            joinPlane: JoinPlane.Bottom,
            indent: 0,
            angle: s.w > 6 ?  90 - angleF4 : s.a + angleF4,
            angleReturn: s.w > 6 ? s.a + angleF4: 0,
            variant: s.w > 6 ? JoinVariant.DoubleAngle : JoinVariant.Angle,
        },
        joinEnd: {
            joinType: JoinType.End,
            joinPlane: JoinPlane.Bottom,
            indent: 0,
            angle:  angleF4,
            variant: JoinVariant.DoubleAngle
        },
    }
    const rs:RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []
    const specIds: string[] = []
    rs.material.push(createDefaultMaterial())
    const resultGetSimpleBoard = await api.getSimpleBoard.build(paramsGetSimpleBoard)
    rs.uvs.push(resultGetSimpleBoard.mesh.uvs)
    const numUvs = rs.uvs.length - 1
    rs.indices.push(resultGetSimpleBoard.mesh.indices)
    const numIndices = rs.indices.length - 1
    rs.vertices.push(resultGetSimpleBoard.mesh.vertices)
    const numVertices = rs.vertices.length - 1
    const nameGroup = 'F4'
    const specID = nameGroup
    rs.group = nameGroup
    const numGroups = rs.group.length
    const meta = resultGetSimpleBoard.meta

    const realSeg = centeredLine(CP.maps.f1.lineCut, s.l)

    const metaJEOffset1End = getMetaNumber(meta.modify, "joinEnd", "offset1")
    const metaJEOffset2End = getMetaNumber(meta.modify, "joinEnd", "offset2")
    const metaJEOffsetStart = getMetaNumber(meta.modify, "joinStart", "offset")

    const line2:Line2 = [[meta.h, 0], [meta.h, meta.l - metaJEOffset2End]]
    const line1:Line2 = [[meta.h / 2, meta.l / 2],[meta.h / 2, meta.l]]
    const line3:Line2 = [[0, 0 + metaJEOffsetStart], [0, meta.l - metaJEOffset1End]]

    const p:Line2[] = [line1, line2, line3]

    const testOfset = getOffsetsAfterRotation(p, Math.PI / 2 + initParam.angles.f4 * Math.PI / 180)

    for (let i = 0; i < realSeg.length - 1; i++) {
        const x = realSeg[i][0] + s.block.w / 2

        const z = s.h
            - initParam.gash.simple
            + initParam.elementData.f1.sizeBoard.h
            + meta.l / 2
            - testOfset.deltaBottom

        const yR = 0
            - initParam.elementData.f2.sizeBoard.w
            - testOfset.deltaLeft

        const yL = 0
            + initParam.elementData.f2.sizeBoard.w
            + testOfset.deltaLeft

        const posR:Vec3 = [x, z, yR]
        const posL:Vec3 = [x, z, yL]

        const boardR: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posR,
            rotation: [Math.PI / 2 + initParam.angles.f4 * Math.PI / 180, 0, 0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
            specId: specID
        }
        rs.elements.push(boardR)

        const boardL: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posL,
            rotation: [-Math.PI / 2 - initParam.angles.f4 * Math.PI / 180, Math.PI, 0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
            specId: specID
        }
        rs.elements.push(boardL)
    }
    spec.push({
        w: resultGetSimpleBoard.meta.w,
        h: resultGetSimpleBoard.meta.h,
        l: resultGetSimpleBoard.meta.l,
        name: "Ферма - элемент №4",
        group: specID,
        count: (realSeg.length - 1) * 2,
        specId: specID
    })
    specIds.push(specID)
    rs.specIds = specIds


    return {rs: rs, spec: spec}
}
